import type { IKeywords } from "app/pages/digital-marketing/brand-monitoring-campaigns/wizard/wizard-pages/adding-keywords-step/keywords-table/BrandMonitoringCampaignTableConsts";

export const ADD_MANUALLY_DUPLICATE_KEYWORDS_KEY =
    "paid.brandMonitoringCampaign.wizard.addingKeywordsStep.topBar.addKeywordManually.duplicatedKeywords";
export const ADD_MANUALLY_DUPLICATE_KEYWORD_KEY =
    "paid.brandMonitoringCampaign.wizard.addingKeywordsStep.topBar.addKeywordManually.duplicateKeyword";
export interface IAddingKeywordsTableTopResult {
    keywords: IKeywords[];
    toastMessage: string[];
    amountOfNewKeywords: number;
}
